/*
Code for the image carousel on the Home Page
*/

import { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import balch from "./images/entrance.jpg";
import rosegarden from "./images/rosegarden.jpg";
import path from "./images/path.jpg";
import keck from "./images/keck.jpg";
import denison_back from "./images/denison_back.jpg";
import sunset from "./images/sunset_bright.JPG";

function ControlledCarousel() {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <div className="carousel_container">
      <Carousel activeIndex={index} onSelect={handleSelect}>
        <Carousel.Item>
          <img className="d-block w-100" src={rosegarden} alt="Second slide" />
          <Carousel.Caption>
            <a href="/" className="carousel_title">
              <h3 className="carousel_title">Data Science Minor</h3>
            </a>
            <p className="carousel_text">
              Data Science students study a blend of math, statistics, and
              computer science to gain robust analytical skills
            </p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src={balch} alt="Second slide" />
          <Carousel.Caption>
            <a href="/courses" className="carousel_title">
              <h3 className="carousel_title">Courses</h3>
            </a>
            <p className="carousel_text">
              Five core areas and two upper division electives
            </p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src={keck} alt="Second slide" />
          <Carousel.Caption>
            <a href="/faculty" className="carousel_title">
              <h3 className="carousel_title">Faculty</h3>
            </a>
            <p className="carousel_text">Meet our Data Science professors</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src={sunset} alt="Second slide" />
          <Carousel.Caption>
            <a href="/resources" className="carousel_title">
              <h3 className="carousel_title">5C Resources</h3>
            </a>
            <p className="carousel_text">
              Clubs, websites, and resources for students interested in DS, CS,
              and other technical fields
            </p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={denison_back}
            alt="Second slide"
          />
          <Carousel.Caption>
            <a href="/careers" className="carousel_title">
              <h3 className="carousel_title">Careers</h3>
            </a>
            <p className="carousel_text">
              Data Science can be applied to any career. Here are a few example
              paths.
            </p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src={path} alt="Second slide" />
          <Carousel.Caption>
            <a href="/faq" className="carousel_title">
              <h3 className="carousel_title">FAQs</h3>
            </a>
            <p className="carousel_text">
              The most frequently asked questions from Data Science students
            </p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </div>
  );
}
export default ControlledCarousel;
